<template>
  <div class="select">
    <div class="wrapper">
      <div class="container">
        <div class="left">
          <div class="content">
            <back-action />
            <h1>Heb je een Erasmus Accreditatie?</h1>
          </div>
        </div>
        <div class="right">
          <div class="content" id="main">
            <div class="inner">
              <div class="rows">
                <router-link :to="{ name: 'AccreditatieResult'}" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">Ja</span>
                      <span class="sub">Ik heb een Erasmus Accreditatie</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
                <router-link to="/ka122-vet" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">Mijn organisatie heeft geen Erasmus accreditatie</span>
                      <span class="sub">en wil een korte-termijn mobiliteits-project met een klein aantal studenten en/of medewerkers (max 30) uitvoeren.</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
                <router-link to="/ka120-lsv" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">Mijn organisatie heeft geen Erasmus accreditatie</span>
                      <span class="sub">en wil namens een groep Nederlandse (onderwijs) organisaties een mobiliteitsproject aanvragen (consortiumaanvraag)</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
                <router-link to="/ka120-vet" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">Mijn organisatie heeft geen Erasmus accreditatie</span>
                      <span class="sub">en is op zoek naar een duurzame, lange-termijn deelname aan Erasmus+ mobiliteitsprojecten.</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
